<input #input
       class="text-boxes"
       [attr.data-test-id]="dataTestId"
       [attr.id]="inputId ? inputId : null"
       [class.darkField]="darkField"
       [class.autocompleteListShow]="showSuggestion"
       [class.with-icon]="iconClass || eyeMode"
       [type]="type"
       (keydown.enter)="onInputKeydownEnter($event)"
       (keydown.escape)="onInputKeydownEscape($event)"
       [class.disabled]="disabled || readonly"
       [class.invalid]="invalid"
       [tabindex]="tabindex"
       [readonly]="readonly"
       [name]="name"
       [ngModel]="value"
       [autocomplete]="autocomplete"
       (ngModelChange)="inputValueChanged($event)"
       [placeholder]="placeholder"
       (focus)="onInputFocus($event)"
       (input)="onInputChange($event)"
       (blur)="onInputBlur($event)"/>
<div class="eye iconsax" [iconName]="isPasswordShow ? 'eye-slash' : 'eye'"  *ngIf="eyeMode" (click)="eyeClick()"></div>
<div #autocompleteList class="autocompleteList" *ngIf="filteredSuggestions.length && showSuggestion">
    <div class="suggestedOption" *ngFor="let item of filteredSuggestions;" (click)="selectOption(item)">
        {{item}}
    </div>
</div>
<ng-content></ng-content>
<ui-button
    *ngIf="showMagnifier"
    class="magnifier-icon"
    justIcon="true"
    iconName="search-normal-2"
    iconColor="gray"
></ui-button>
<ui-button
    *ngIf="showClearButton"
    (click)="clearField()"
    class="close-icon"
    iconName="close-circle"
    iconColor="gray"
></ui-button>
